export default "__VITE_ASSET__DMm9YolN__"